import "./src/pages/index.css";
require('typeface-gurajada');
require('typeface-noto-sans');

export const onClientEntry = () => {
    if (!(`IntersectionObserver` in window)) {
      require(`intersection-observer`)
      console.log(`# IntersectionObserver is polyfilled!`)
    }
  }